export const generateYearOptions = (startYear = 2019, endYearOffset = 3) => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + endYearOffset;
  const years = [];

  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }

  return years;
};

export const formatYear = (year) => {
  const yearNum = parseInt(year, 10);
  const current = new Date().getFullYear();

  if (yearNum === current) {
    return `${year} (Current)`;
  }
  if (yearNum > current) {
    return `${year} (Future)`;
  }
  return String(year);
};

const YEAR_VALUE_SELECTOR_DISCLOSURE_CODES = new Set(["COM004"]);

export const isDisclosureYearValueSelector = (disclosure) =>
  YEAR_VALUE_SELECTOR_DISCLOSURE_CODES.has(
    String(disclosure?.code || "").trim(),
  ) &&
  disclosure?.inputType === "valueUnit" &&
  disclosure?.defaultUnit === "Year";

export const getDisclosureYearValueOptions = (disclosure) =>
  isDisclosureYearValueSelector(disclosure)
    ? generateYearOptions(2018, 0).map((year) => ({
        value: String(year),
        label: formatYear(year),
      }))
    : [];

export const generateTargetYearOptions = (
  startYear = 2026,
  endYearOffset = 10,
) => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + endYearOffset;
  const years = [];

  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }
  return years;
};
